export default "__VITE_ASSET__CPPYRFGB__"